// extracted by mini-css-extract-plugin
module.exports = {"openDialogButton":"styles_openDialogButton__yrB2x","buttonContainer":"styles_buttonContainer__3_hsa","openDialogIcon":"styles_openDialogIcon__2Ejmb"};